import { Component, EventEmitter, Input, Output, ViewChild, } from '@angular/core';
import { User } from '../../../core/models/user.model';
import { UserService } from '../../../../services/user/user.service';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { Subscription } from 'rxjs';
import { CoreService } from '../../../core/core.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { newUserPasswordFormConfig } from '../../config/new-user-password-form.config';
import { Message } from 'primeng/api';
import { passwordMatchValidator, syncPasswordMismatchError } from '../../../core/validators/password.validator';

@Component({
  selector: 'app-user-change-password-form-dialog',
  templateUrl: './user-change-password-form-dialog.component.html',
  styleUrl: './user-change-password-form-dialog.component.scss'
})
export class UserChangePasswordFormDialogComponent {
  private subscriptions: Subscription[] = [];
  @ViewChild('eoForm', { static: false }) eoForm!: EoFormComponent;
  @Input() forceChange = false;

  user?: User;
  visible = false;
  formConfig = [...newUserPasswordFormConfig];
  message: Message[] = [];

  @Output() success = new EventEmitter();

  constructor(
    private readonly authService: AuthService,
    private coreService: CoreService
  ) { }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.newUserPasswordForm) return;

    const newUserPswDto = {
      oldPassword: $event.newUserPasswordForm.oldPassword,
      newPassword: $event.newUserPasswordForm.password,
    };

    this.authService.updatePassword(newUserPswDto).subscribe(
      () => this.onSubmitSuccess()
    );
  }

  private onSubmitSuccess(): void {
    this.authService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }


  private initForm() {
    if (!this.eoForm) return;

    this.eoForm.form.reset();
    this.eoForm.form.enable();

    this.message = [
      {
        severity: 'info',
        detail: `
        <p>Ο κωδικός πρόσβασης πρέπει να συμβαδίζει με τους ακόλουθους κανόνες:</p>
          <ul class="ml-4">
            <li>Μήκους τουλάχιστον 8 χαρακτήρες</li>
            <li>Τουλάχιστον 1 σύμβολο (π.χ. $@!%*#?&)</li>
            <li>Τουλάχιστον 1 νούμερο</li>
            <li>Τουλάχιστον 1 λατινικό χαρακτήρα (a-z/A-Z)</li>
          </ul>  
          <br>      
    `,
      }
    ];
  }

  private showSuccessMessage(): void {
    this.coreService.showSuccess('Η αλλαγή κωδικού έγινε με επιτυχία');
  }

  getHeader(): string {
    return 'Aλλαγή κωδικού χρήστη';
  }

  getFormConfig() {
    return this.formConfig;
  }

  isSubmitLoading(): boolean {
    const UpdatePasswordStatus = this.authService.updatePasswordCallHandler?.status$?.getValue();
    return UpdatePasswordStatus === STATUS.loading;
  }

  show(): void {
    this.initForm();
    this.visible = true;
  }

  ngAfterViewChecked(): void {
    const userPaswordFormGroup = this.eoForm?.form.get('newUserPasswordForm');
    if (!userPaswordFormGroup) return;

    userPaswordFormGroup.setValidators(passwordMatchValidator());
    syncPasswordMismatchError(userPaswordFormGroup);
  }
}
